import React, { useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import SimpleBar from 'simplebar-react';
import MetisMenu from 'metismenujs';
import withRouter from 'components/Common/withRouter';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { MANUFACTURER_PATHS, SHOP_PATHS, USER_PATHS } from '../../../../routes/routesConstants';
import { usePermissions } from 'context/PermissionProvider';
import { PERMISSIONS } from 'constants/permissions';

const SidebarContent = (props) => {
  const { hasPermission, hasAnyPermission } = usePermissions();
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add('active');
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== 'side-menu') {
      parent2El.classList.add('mm-show');
    }

    if (parent) {
      parent.classList.add('mm-active');
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add('mm-show'); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add('mm-active'); // li
          parent3.childNodes[0].classList.add('mm-active'); // a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add('mm-show'); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add('mm-show'); // li
              parent5.childNodes[0].classList.add('mm-active'); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains('active')) {
        item.classList.remove('active');
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.remove('mm-show');
        }

        parent.classList.remove('mm-active');
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove('mm-show');

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove('mm-active'); // li
            parent3.childNodes[0].classList.remove('mm-active');

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove('mm-show'); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove('mm-show'); // li
                parent5.childNodes[0].classList.remove('mm-active'); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById('side-menu');
    const items = ul.getElementsByTagName('a');
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu('#side-menu');
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t('Menu')}</li>
            {/* <li>
              <Link to="/file">
                <i className="bx bx-file"></i>
                <span>{props.t('Dashboard')}</span>
              </Link>
            </li>
            <li className="menu-title">{props.t('Shop Management')}</li> */}
            {hasAnyPermission([PERMISSIONS.VIEW_SHOPS, PERMISSIONS.MANAGE_SHOPS]) && (
              <li>
                <Link to="/shops" className="has-arrow">
                  <i className="bx bx-store"></i>
                  <span>{props.t('Shops')}</span>
                </Link>
                <ul className="sub-menu">
                  {hasPermission(PERMISSIONS.VIEW_SHOPS) && (
                    <li>
                      <Link to="/shops">
                        <i className="bx bx-list-ul"></i>
                        <span>{props.t('All Shops')}</span>
                      </Link>
                    </li>
                  )}
                  {hasPermission(PERMISSIONS.MANAGE_SHOPS) && (
                    <li>
                      <Link to="/shops/add">
                        <i className="bx bx-plus-circle"></i>
                        <span>{props.t('Add Shop')}</span>
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {hasAnyPermission([PERMISSIONS.VIEW_MANUFACTURERS, PERMISSIONS.MANAGE_MANUFACTURERS]) && (
              <>
                <li className="menu-title">{props.t('Manufacturers')}</li>
                <li>
                  <Link to={MANUFACTURER_PATHS.BASE} className="has-arrow">
                    <i className="bx bx-cart"></i>
                    <span>{props.t('Manufacturers')}</span>
                  </Link>
                  <ul className="sub-menu">
                    {hasPermission(PERMISSIONS.VIEW_MANUFACTURERS) && (
                      <li>
                        <Link to={MANUFACTURER_PATHS.BASE}>
                          <i className="bx bx-list-ul"></i>
                          <span>{props.t('All Manufacturers')}</span>
                        </Link>
                      </li>
                    )}
                    {hasPermission(PERMISSIONS.MANAGE_MANUFACTURERS) && (
                      <li>
                        <Link to={MANUFACTURER_PATHS.ADD_MANUFACTURER}>
                          <i className="bx bx-plus-circle"></i>
                          <span>{props.t('Add Manufacturer')}</span>
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              </>
            )}

            {hasAnyPermission([
              PERMISSIONS.VIEW_STAFF,
              PERMISSIONS.CREATE_STAFF,
              PERMISSIONS.VIEW_PERMISSIONS,
            ]) && (
              <>
                <li className="menu-title">{props.t('Employees')}</li>
                <li>
                  <Link to={USER_PATHS.BASE} className="has-arrow">
                    <i className="bx bx-user-circle"></i>
                    <span>{props.t('Employee Management')}</span>
                  </Link>
                  <ul className="sub-menu">
                    {hasPermission(PERMISSIONS.VIEW_STAFF) && (
                      <li>
                        <Link to={USER_PATHS.BASE}>
                          <i className="bx bx-list-ul"></i>
                          <span>{props.t('All Employees')}</span>
                        </Link>
                      </li>
                    )}
                    {hasPermission(PERMISSIONS.CREATE_STAFF) && (
                      <li>
                        <Link to={USER_PATHS.ADD_USER}>
                          <i className="bx bx-plus-circle"></i>
                          <span>{props.t('Add Employee')}</span>
                        </Link>
                      </li>
                    )}
                    {hasPermission(PERMISSIONS.VIEW_PERMISSIONS) && (
                      <li>
                        <Link to={USER_PATHS.PERMISSIONS}>
                          <i className="bx bx-shield"></i>
                          <span>{props.t('Permissions')}</span>
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              </>
            )}

            {hasAnyPermission([PERMISSIONS.VIEW_SETTINGS, PERMISSIONS.EDIT_SETTINGS]) && (
              <li>
                <Link to={SHOP_PATHS.BUSINESS_SETTINGS}>
                  <i className="bx bx-buildings"></i>
                  <span>{props.t('Business Settings')}</span>
                </Link>
              </li>
            )}

            {/* <li>
              <Link to="/medicines">
                <i className="bx bx-capsule"></i>
                <span>{props.t('Medicines')}</span>
              </Link>
            </li>
            <li>
              <Link to="/sales">
                <i className="bx bx-receipt"></i>
                <span>{props.t('Sales')}</span>
              </Link>
            </li>
            <li>
              <Link to="/reports">
                <i className="bx bx-bar-chart-alt"></i>
                <span>{props.t('Reports')}</span>
              </Link>
            </li>
            <li>
              <Link to="/basic-data">
                <i className="bx bx-data"></i>
                <span>{props.t('Basic Data')}</span>
              </Link>
            </li>
            <li>
              <Link to="/maintenance">
                <i className="bx bx-wrench"></i>
                <span>{props.t('Maintenance')}</span>
              </Link>
            </li>
            <li>
              <Link to="/window">
                <i className="bx bx-window"></i>
                <span>{props.t('Window')}</span>
              </Link>
            </li>
            <li>
              <Link to="/help">
                <i className="bx bx-help-circle"></i>
                <span>{props.t('Help')}</span>
              </Link>
            </li> */}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
